import localforage from 'localforage';
import uuidGenerator from 'services/uuid';

class LocalForage {
  constructor() {
    this.store = localforage;
    this.store.config({
      driver: localforage.INDEXEDDB,
      name: '_ql',
      version: 1.0,
      description: 'Store quicklegal user data',
    });
  }

  getFormData() {
    return this.store.getItem('session').then(session => session || {
      uuid: uuidGenerator(),
      documents: [],
      index: {
        forWho: 'me',
        showModal: true,
      },
      step1: {},
      step2: {},
      step3: {},
      step4: {},
      step5: {},
      step6: {},
      step7: {},
      step8: {},
      step9: {},
      step10: {},
    });
  }
}

export default new LocalForage();




// WEBPACK FOOTER //
// ./src/services/localforage.js